import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { uniformeModulo } from 'src/app/aplicaciones-modulos/spyral/diccionarios/uniformeModule';
import { ClothesEmployeSendModel } from '../model/clothesEmployeSendModel';

@Injectable({
  providedIn: 'root'
})
export class ClothesEmployeService {

  diccionarioUrl: any;
  urlUniforme: string;
  constructor(private commom: CommonService,
    private utilServices: UtilsService) {
    this.urlUniforme = this.utilServices.getUniforme();
    this.diccionarioUrl = uniformeModulo.url.uniforme;
  }

  findInfoEmploye(cedula: string){
    return this.commom.peticionGetConHeader(this.urlUniforme + this.diccionarioUrl.clothesEmploye.url + 
        this.diccionarioUrl.clothesEmploye.findInfoEmploye + '/'+ cedula);
  }

  resteQuote(){
    return this.commom.peticionPostConHeader(this.urlUniforme + this.diccionarioUrl.clothesEmploye.url + 
        this.diccionarioUrl.clothesEmploye.reset_quote, null);
  }

  createEditClothesEmployee(cedula: string, clothesEmployee: ClothesEmployeSendModel[]){
    return this.commom.peticionPostConHeader(this.urlUniforme + this.diccionarioUrl.clothesEmploye.url + '/' + cedula, clothesEmployee);
  }

  uploadFile(formData: FormData) {
    return this.commom.peticionPostConHeader(this.urlUniforme + this.diccionarioUrl.clothesEmploye.url + '/upload', formData);
  }

  downloadEntrega(ciUser: string) {
    return this.commom.peticionGetConHeader(this.urlUniforme + this.diccionarioUrl.clothesEmploye.url + '/deliver/' + ciUser);
  }

}
